import React from 'react';
import copy from 'copy-to-clipboard';
import { Divider, notification } from 'antd';
import './Profile.scss';
import { ROLES } from '../../../constants';

const API = ({ user }) => {
  const onClickCopy = (value) => {
    copy(value);
    notification.success({ message: 'Copied' });
  };

  // Function to transform the API key for display
  const displayApiKey = (apiKey) => {
    if (apiKey && apiKey.length > 5) {
      return '• '.repeat(apiKey.length - 5) + apiKey.substr(-5);
    }
    return apiKey || '-';
  };

  return (
    <div className="info">
      <div className="info-content">
        <h3>API</h3>
        <h5>Find your credentials for access to our API</h5>
      </div>
      <div className="info-content id-copy">
        <label>API Key</label>
        <p>
          {displayApiKey(user.apiKey)}{' '}
          <img src="/icons/file_copy.svg" alt="Copy" onClick={() => onClickCopy(user.apiKey)} />
        </p>
      </div>
      {user.role === ROLES.COMPANY_OWNER && (
        <>
          <Divider />
          <div className="info-content">
            <h3>Location</h3>
            <h5>Use your location ID in your API calls</h5>
          </div>
          <div className="info-content id-copy">
            <label>Location&apos;s ID&apos;s</label>
            {user.locations?.map((l) => (
              <div key={l.locationId}>
                <div className="grid grid-cols-4 gap-4">
                  <p>{l.name}</p>
                  <div className="flex">
                    <p>{l.locationId}</p>
                    <img className="ml-2" src="/icons/file_copy.svg" alt="Copy" onClick={() => console.log(user)} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      )}
      <Divider />
      <div className="info-content">
        <label>Documentation</label>
        <p>
          Please find the documentation for the API{' '}
          <a href="https://sparqle-api.readme.io" target="_blank" rel="noopener noreferrer">
            here
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default API;
